export const lanxiongDesc: string = `懒熊体育成立于2013年底，2015年6月在北京开始公司化运营，同期设立上海办公室，是领先的商业体育内容提供商，现已成为中国体育产业的综合型服务平台，致力于服务好每一家有体育相关业务的B端公司，让体育产业高效连接。

懒熊体育通过内容传播，聚拢了超30万+B端的体育产业精英，他们构成懒熊体育的核心用户，其中包含上万位创业者（数据库已收录数千份商业计划书）、千余家有意投资体育项目的投资机构和超2000位项目投资人，一起搭建互通有无的线上平台，成为了中国体育产业中的知名品牌。

懒熊体育到目前共完成四轮融资：2015年7月，懒熊体育获得联科创盈200万元的天使投资；2016年3月，又完成1200万的Pre-A轮融资，此轮由华人文化领投、九合创投跟投，同时宣布成立体育产业早期投资基金元迅投资，基金规模为1亿元人民币；9月19日，懒熊体育在中国体育产业集市上宣布完成4200万A轮融资，上轮投资方华人文化继续领投，熠帆资本、娱乐工场、贵格基金跟投；2017年1月，腾讯战略入股懒熊体育。

截至2023年7月，懒熊体育累计推出原创产业报道超5万篇，微信矩阵（懒熊青少年体育、运动连锁指南等）聚集B端产业精英超30万；官方微博粉丝已超184万，另外拥有分别关注B端和C端内容的微博矩阵，总粉丝量已超2000万；懒熊体育官网www.lanxiongsports.com访问量保持稳定增长，目前年均访问人次超过1000万。

除了两微一网，懒熊体育已入驻36氪、虎嗅、今日头条、知乎、ZAKER、Flipboard、天天快报、一点资讯、百度百家、懂球帝以及新浪、腾讯等各大体育门户，目前在各渠道的总阅读量已超100亿。此外，懒熊体育还对外输出英文版原创体育产业报道，已经与Leaders、Soccerex、iSportconnect等国外体育商业平台建立起深度合作关系。

基于内容报道，懒熊体育衍生出了金融咨询、智库培训和企业服务三大核心业务板块。这四条线相互打通和配合，让体育产业的人才、项目和资金产生连接，一起分享知识、碰撞观点、交换资源、完成交易，这也是懒熊体育现在的商业模式。

懒熊上海站：上海站是北京公司核心业务的自然延伸，负责上海以及周边地区体育相关公司的内容报道、行业调研、业务合作和商务拓展。
`;

export const mediaDesc: string = `内容创作致力于提供客观、独立、原创、深度的公司报道、行业调研和数据汇编。产品覆盖文字、图片报道、数据可视化以及独立的音频、视频等产品形态。

目前在北京、上海两地办公，内容创作团队接近30人，大部分拥有如《第一财经周刊》、《中国企业家》、《财经天下》、体坛周报、新浪体育、虎扑体育等专业财经或体育媒体的工作背景，堪称中国商业体育报道梦之队。

在内容创作之外，我们业务部门这一年多也取得了突破式发展，内容策划和咨询、投融资对接、智库高管培训和产业峰会合作等成为了我们的王牌产品，我们为近20个项目做商业模式梳理、帮他们完成融资，我们将哈佛商学院最年轻的教授Anita Elberse请到中国，我们的体育培训商业课在北上广等城市备受追捧。

在商业化的过程中，懒熊体育的目标愈发清晰，就是帮助产业中的B端企业解决人或者钱的问题，同时让他们互通有无，实现高效连接。

通过内容创作做影响力，通过B端资源做营收，两手抓两手都要硬，这就是我们的核心商业模式。

内容创作需求请添加 懒熊小秘书（微信号：lanxiongmishu），业务合作扫码请添加商务专员 小熊（微信号：13436937955）
`;

export const zhikuDesc: string = `懒熊体育产业智库于2016年5月推出，专注于体育产业发展趋势和体育公司经营方法的总结与分析，目的是为中国体育产业的经营者和投资人提供深入的行研、咨询和培训服务。智库会员业务推出后，到目前已发布8期报告，包括《2015体育创业白皮书》、《2016体育创业白皮书》、《新三板体育公司系列报告（第一版）》、《2017版新三板体育公司报告》、《2016体育产业白皮书之IP体育报告》、《体育运动业态与商业地产报告》、《电子竞技产业报告》、《骑行运动人群报告》，吸纳付费会员超千人。

懒熊智库的新产品——体育商业课——已在10月发布，这是基于微信的线上小程序平台。线上课程将是懒熊体育商业课线下主题课程的补充，我们将邀请体育产业各领域公司的高级管理者、跨行业的专家人士，通过视频或音频讲授他们从业多年所积累的行业实操经验和方法论知识。课程主题将会涉及体育商业的各个领域，包括赛事运营、体育营销、品牌打造、体育创业、各业态公司管理运营方法论等


同时，懒熊体育也希望这个线上课程平台能够汇集更多业界智慧，有更多体育行业内外的企业家、管理者及业务专家能够在平台上传授他们的行业经验，一起助力中国体育产业升级。懒熊体育在此发出邀请，邀请各位业界大咖到懒熊体育商业课线上平台传道授业。课程咨询请添加 懒熊智库（微信号：lanxiongzhiku）。

咨询将是智库未来的另一重点业务，结合体育综合体和运动休闲小镇的前期规划和后期配置，懒熊体育将集全平台资源来推动产业整合。
`;

export const FADesc: string = `2016年9月，懒熊体育宣布联合华人文化和联科创盈成立元迅基金，专注体育行业的早期项目，基金规模为1亿元人民币。截至目前，元迅已投下约15个垂直体育项目，其中有著名足球运动员孙继海创办的嗨球、青少年户外培训的夏山童子军、新型体育营销公司门派、海派新型连锁健身消费公司V+健身等。

除投资之外，体育行业一级市场的资产交易是更大的蓝海。2017年初，懒熊体育FA业务部门正式成立，到目前为止，已经帮助运动装备品牌小三角、国内最大赛事转播运营商环宇体育、新型健身连锁消费服务公司壹季体能、高端2B的网球培训好动网球、北美知名运动饮料品牌在国内落地的百淬，以及华人红杉投资首轮的国内顶级搏击IP勇士的荣耀等近20个项目完成融资，累计交易额近3亿元，迅速成为了体育行业一级市场领先的投融资服务平台。
`;

export const serviceDesc: string = `懒熊体育的活动线自2015年6月起正式运营，通过X变量投融资活动、人才招聘沙龙、中国体育产业集市等活动，为体育产业打造了首个集知识交易、股权交易、人才交易、资源交易的线下服务平台，每年主办的中国体育产业嘉年华，已成为中国体育产业领先的线下狂欢节和产业精英的顶级社交聚会。

除此之外，以懒熊公开课为基础，懒熊社群已吸纳产业精英超万人，是体育产业目前规模最大的学习社群；“鹰熊会”则是中国体育产业极具创新活力的CEO组织，帮助会员进行连接、合作、交易和共享；视频产品《鹰熊TALK》已经包装推广数十位跨界体育达人。

通过线上和线下的活动产品，懒熊体育将持续为品牌提供一站式的整合营销服务。在体育营销方面服务过的客户包括科比篮球训练营、奥瑞金NHL中国赛、石家庄（正定）国际马拉松以及北美职业体育联盟赛事等众多知名赛事和品牌。
`;

export const reportList: Array<{
  title: string;
  link: string;
  name: string;
  logo: string;
}> = [
  {
    title: '2023，体育产业从业者“等待上场”',
    link: 'http://www.news.cn/sports/2023-01/13/c_1129278588.htm',
    name: '新华网',
    logo: 'https://imgcdn.lanxiongsports.com/lx-about/xinhuashe.jpg',
  },
  {
    title: '第七届体育产业嘉年华在北京成功举办',
    link: 'https://item.btime.com/42i0j5iahj593iratcequ7dd73h',
    name: '北京广播电视台',
    logo: 'https://imgcdn.lanxiongsports.com/lx-about/BTV.png',
  },
  {
    title: '业界论道体育产业发展：“新物种”涌现 尝试才有机会',
    link: 'http://www.chinanews.com.cn/ty/2023/01-12/9933392.shtml',
    name: '中新网',
    logo: 'https://imgcdn.lanxiongsports.com/lx-about/chinanews.png',
  },
  {
    title: '2022年体育产业投融资遇冷，小众运动、户外经济仍受资本青睐',
    link: 'https://m.21jingji.com/article/20230113/herald/e43af0c4b2250fa0ef49ef830ea658a9.html',
    name: '21世纪经济报道',
    logo: 'https://imgcdn.lanxiongsports.com/lx-about/21caijing.png',
  },

  {
    title: '当体育离“刚需”越来越近 体育产业探索新机遇',
    link: 'https://xhpfmapi.zhongguowangshi.com/vh512/share/9691434',
    name: '新华财经',
    logo: 'https://imgcdn.lanxiongsports.com/lx-about/xinhuashe.jpg',
  },
  {
    title: '电竞是不是体育再引争议，中国体育产业上演“头脑风暴”',
    link: 'https://m.thepaper.cn/newsDetail_forward_10786653',
    name: '澎湃新闻',
    logo: 'https://imgcdn.lanxiongsports.com/lx-about/pengpai.jpg',
  },
  {
    title: '2020国内体育产业融资金额创五年新低 体育版权估值“一夜回到解放前”',
    link: 'http://www.nbd.com.cn/articles/2021-01-13/1597007.html',
    name: '每日经济新闻',
    logo: 'https://imgcdn.lanxiongsports.com/lx-about/meijingwang.jpg',
  },
  
  {
    title: '疫情下体育产业如何“蓄势而上”，不妨从这五点观察“对症下药”',
    link: 'https://n.eastday.com/pnews/1610606972023499',
    name: '东方网',
    logo: 'https://imgcdn.lanxiongsports.com/lx-about/dongfangwang.jpg',
  },
  {
    title: '懒熊体育第五届体育产业嘉年华在上海举办”',
    link: 'https://36kr.com/p/1053843739988097',
    name: '36氪',
    logo: 'https://imgcdn.lanxiongsports.com/lx-about/logo_36k@2x.jpg',
  },
  {
    title: '新华社中国体育报等百余家媒体关注第四届体育产业嘉年华',
    link: 'http://www.lanxiongsports.com/posts/view/id/17615.html',
    name: '新华社',
    logo: 'https://imgcdn.lanxiongsports.com/lx-about/logo_xhw@2x.jpg',
  },
  {
    title: '体育产业如何“和自己赛跑”？',
    link: 'http://capital.people.com.cn/n1/2019/0118/c405954-30577675.html',
    name: '人民网',
    logo: 'https://imgcdn.lanxiongsports.com/lx-about/logo_rmw@2x.jpg',
  },
  {
    title: '2018，体育产业路在何方？',
    link: 'http://www.xinhuanet.com/2018-01/01/c_1122194050.htm',
    name: '新华网',
    logo: 'https://imgcdn.lanxiongsports.com/lx-about/logo_xhw@2x.jpg',
  },
  {
    title: '懒熊体育CEO韩牧：中国体育需要千里马而非独角兽',
    link:
      'http://sports.sina.com.cn/other/2017-01-11/doc-ifxzkfuh6932387.shtml',
    name: '新浪体育',
    logo: 'https://imgcdn.lanxiongsports.com/lx-about/logo_xlty@2x.jpg',
  },
  {
    title: '懒熊体育完成A轮4200万融资 华人文化继续领投',
    link: 'https://tech.qq.com/a/20160919/039901.htm',
    name: '腾讯科技',
    logo: 'https://imgcdn.lanxiongsports.com/lx-about/logo_txkj@2x.jpg',
  },
  {
    title: '中国体育产业跨界峰会 揭晓十大体育商业领袖',
    link: 'http://sports.ifeng.com/a/20160518/48794817_0.shtml',
    name: '凤凰体育',
    logo: 'https://imgcdn.lanxiongsports.com/lx-about/logo_fhty@2x.jpg',
  },
//  {
//    title: '懒熊体育完成1200万Pre-A融资，以媒体切入，在体育商业领域填补空白',
//    link: 'https://36kr.com/p/5045010',
//    name: '36氪',
//    logo: 'https://imgcdn.lanxiongsports.com/lx-about/logo_36k@2x.jpg',
//  },
];
